import { LanguageEnum } from "generated/graphqlExternal";
import { LanguagesEnum } from "globalConstants/languagesEnum";

const LOCALE_TO_LANGUAGE: Record<LanguageEnum, LanguagesEnum> = {
  [LanguageEnum.EnUs]: LanguagesEnum.americanEnglish,
  [LanguageEnum.EsEs]: LanguagesEnum.spanish,
  [LanguageEnum.PtBr]: LanguagesEnum.brazilianPortuguese,
};

export const mapInviteLocaleToLanguage = (locale: LanguageEnum): LanguagesEnum => LOCALE_TO_LANGUAGE[locale];
